import { BrowserCacheLocation, Configuration, PopupRequest } from "@azure/msal-browser";
import Config from "./constants/Configuration";


// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: Config.clientId,
        authority: `https://login.microsoftonline.com/${Config.TenantId}`,
        redirectUri: "/",
        postLogoutRedirectUri: "/",
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true, // set to true for IE 11
    },
    system: {
        loggerOptions: {
            loggerCallback: () => { },
            piiLoggingEnabled: false
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.

export const loginRequest: PopupRequest = {
    scopes: [`api://${Config.ApiClientId}/.default`,],
};


// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

